<app-loader></app-loader> 
<mat-sidenav-container>
    <!-- Sidenav: a largura é definida de acordo com o estado (expandido ou colapsado) -->
    <mat-sidenav opened mode="side" [style.width]="sidenavWidth" class="custom-sidenav">
      <!-- Área fixa do logo -->
      <div class="sidenav-header">
        <a [routerLink]="'home'">
            <img width="50" src="../assets/images/viresco-icon.png" alt="Logo" class="logo" *ngIf="!isExpanded" />
            <img width="150" src="../assets/images/viresco-logo.png" alt="Logo" class="logo" *ngIf="isExpanded" />
        </a>
    </div>
      <!-- Área scrollável do menu -->
      <div class="menu-scroll">
        <app-menu  [isLateral]="!isExpanded"></app-menu>
      </div>
    </mat-sidenav>
    
    <!-- Conteúdo: a margem esquerda acompanha a largura do sidenav -->
    <mat-sidenav-content [style.marginLeft]="sidenavWidth">
      <mat-toolbar class="">
        <!-- Botão do menu à esquerda -->
        <button mat-icon-button (click)="toggleMenu()">
          <mat-icon>menu</mat-icon>
        </button>
        
        <!-- Elemento spacer que ocupa o espaço disponível -->
        <span class="toolbar-spacer"></span>
        
        <img *ngIf="logoSaguiCliente" class="logoClienteViresco" src="data:image/jpg;base64,{{logoSaguiCliente}}" />
        <app-notification></app-notification>    
        <div>
            <!-- Este é o "balão" clicável com as iniciais que aciona o menu -->
            <button mat-icon-button [matMenuTriggerFor]="userMenu" aria-label="Abrir menu do usuário">
              <div class="avatar-circle">
                <span class="initials">{{ iniciaisUsuario }}</span>
              </div>
            </button>
    
            <!-- Este é o menu que será aberto. #userMenu é a referência local -->
            <mat-menu #userMenu="matMenu" xPosition="before">
              
              <!-- Seção 1: Informações do Usuário (desabilitado, não clicável) -->
              <div mat-menu-item disabled class="user-info-section">
                <div class="user-info-container">
                  <span>Logado como</span>
                  <strong class="user-name">{{ usuario?.name }}</strong>
                  <span class="user-email">{{ usuario?.username }}</span>
                </div>
              </div>
    
              <mat-divider></mat-divider>
    
              <!-- Seção 2: Botão de Sair -->
              <button mat-menu-item (click)="LogOut()">
                <mat-icon>exit_to_app</mat-icon>
                <span>Sair</span>
              </button>
    
              <mat-divider></mat-divider>
    
              <!-- Seção 3: Versão do Sistema (desabilitado, não clicável) -->
              <div mat-menu-item disabled>
                <span class="version-info">Viresco ERP 2.5.0</span>
              </div>
    
            </mat-menu>
        </div>

      </mat-toolbar>
      
      <div class="content">
        <router-outlet></router-outlet>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
